import { render, staticRenderFns } from "./chargeback-modal-view.vue?vue&type=template&id=f4a1cb3e&scoped=true&"
import script from "./chargeback-modal-view.vue?vue&type=script&lang=js&"
export * from "./chargeback-modal-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a1cb3e",
  null
  
)

export default component.exports